import { BreadcrumbInfoItems } from 'src/components/SimpleBreadcrumb';
import { t } from '@/i18n';

export const breadcrumb: BreadcrumbInfoItems = [
  {
    label: t('pages.application_championship.breadcrumb.championship_label1'),
    link: '/application',
  },
  {
    label: t('pages.application_championship.breadcrumb.championship_label2'),
    link: '/application/championships',
  },
  {
    label: t('pages.application_championship.breadcrumb.championship_label2'),
  },
];
